import { CommApiInstance } from "Utils/CommApiInstance";


const EmlAthnNoVrfRqstApi = async (
    athnNo:string,
    ReCaptchaToken:string
) => {
    return await CommApiInstance.post(`athn/idnt_mthd/eml/athn_no_vrf`,{
        apiBody: {
            athnNo:athnNo,
            cptchTkn:ReCaptchaToken
        }
    })
    .then((Resp) => Resp.data);
}

export default EmlAthnNoVrfRqstApi;